import React from 'react';

export const WalletIcon = ({ color = 'currentColor', className }) => {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Wallet Body */}
      <rect
        x="3"
        y="6"
        width="18"
        height="13"
        rx="2"
        stroke={color}
        strokeWidth="2"
      />

      {/* Wallet Flap */}
      <path
        d="M5 6V4.8C5 3.8 5.8 3 6.8 3H18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Card */}
      <line
        x1="14"
        y1="12"
        x2="18"
        y2="12"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ChevronRightIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 6L15 12L9 18"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
